import API from "../upskill";

// Courses MIX

function getPopularCourses(courses, id) {
  let index = courses.findIndex(c => c.id === id);
  let recommended = [...courses];
  recommended.splice(index, 1);
  recommended = getRandom(recommended, 4)
  return recommended;
}

function getRandom(arr, n) {
  var result = new Array(n),
      len = arr.length,
      taken = new Array(len);
  if (n > len)
    throw new RangeError("getRandom: more elements taken than available");
  while (n--) {
    var x = Math.floor(Math.random() * len);
    result[n] = arr[x in taken ? taken[x] : x];
    taken[x] = --len in taken ? taken[len] : len;
  }
  return result;
}

function getCategories(arr) {
  let categories = new Set(["All"]);
  arr.forEach(course => {
    course.category.split(",").forEach(category => {
      categories.add(category);
    });
  });
  return Array.from(categories);
}
export function getCourses() {
  return new Promise((resolve, reject) => {
    API.getCoursesPremium()
      .then(res => {
        let videos = res.data.data;
        let response = {
          ...videos
        };
        let courses = [];
        Object.keys(response).forEach(key => {
          courses.push(response[key]);
        });
        let categories = getCategories(courses);
        resolve({ courses, categories, access: res.data.access });
      })
      .catch(err => {
        reject(err);
      });
  });
}
export function updateCourse(course, courses, other) {
  let index = courses.findIndex(c => c.id == course.id);
  courses[index] = course;
  let formData = { courses: { data: courses }, other: { data: other } };
  // console.log(formData);
  return new Promise((resolve, reject) => {
    if (!localStorage.getItem("token")) {
      resolve("nothing to update");
    } else {
      API.updateCourse(formData)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    }
  });
}
export function getCourse(id) {
  return new Promise((resolve, reject) => {
    API.getCoursesPremium()
      .then(res => {
        let videos = res.data.data;
        let response = {
          ...videos
        };
        let courses = [];
        Object.keys(response).forEach(key => {
          courses.push(response[key]);
        });
        API.getCoursesPremiumID(id)
          .then(res2 => {
            let c = res.data.data.find(o => o.id == id)
            let resp = {
              course: res2.data,
              popular: getPopularCourses(courses, id),
              selected: c
            };
            resolve(resp);
          })
          .catch(err2 => {
            reject(err2);
          });
      })
      .catch(err => {
        reject(err);
      });
  });
}
